import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecoveryPasswordPageComponent } from './recovery-password-page.component';
import { ContentAuthModule } from '@pacifico/business/auth-flow/components/content-auth/content-auth.module';
import { RecoveryPasswordComponent } from '@pacifico/business/auth-flow/components/recovery-password/recovery-password.component';
import { AlertModule } from '@pacifico/components/alert/alert.module';
import { SharedFormModule } from '@pacifico/shared/shared-forms.module';
import { SharedComponentsModule } from '@pacifico/shared/shared-components.module';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [RecoveryPasswordPageComponent, RecoveryPasswordComponent],
	imports: [CommonModule, ContentAuthModule, AlertModule, SharedFormModule, SharedComponentsModule, RouterModule],
	exports: [RecoveryPasswordPageComponent]
})
export class RecoveryPasswordModule {}
